import { Box, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import addIcon from "../../../src/assets/USA_Images/addIcon.svg";
import "../../../src/FontStyles.css";
import { REACT_ADD_PRODUCT } from "../../actions/EndPoints";
import HeaderToolbar from "../../components/HeaderToolbar";
import EditIcon from "../../Pages/Person/EditIcon";
import { getProducts } from "../../slices/ProductSlice/ProductSlice";

function Products() {
  const { t } = useTranslation();
  const history = useHistory();
  const [responseData, setResponseData] = useState([]);
  const dispatch = useDispatch();
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const headerRef = useRef(null);
  const addIconRef = useRef(null);

  useEffect(() => {
    loadData();
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  const calculateInitialHeight = () => {
    return window.innerHeight - 150;
  };

  const [height, setHeight] = useState(calculateInitialHeight);
  const [initialWindowHeight, setInitialWindowHeight] = useState(
    window.innerHeight
  );

  useEffect(() => {
    const handleResize = () => {
      const percentageChange = (window.innerHeight / initialWindowHeight) * 100;

      setHeight(calculateInitialHeight);
      setInitialWindowHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [initialWindowHeight]);

  const loadData = () => {
    dispatch(getProducts())
      .unwrap()
      .then((res) => {
        if (res.code === "MSGS4000") {
          setResponseData(res.data);
        }
      });
  };

  const handleOpen = () => {
    history.push({
      pathname: REACT_ADD_PRODUCT,
      data: {},
    });
  };

  const hardwareDevices = responseData.filter(
    (product) => product.productType === "HARDWARE"
  );
  const accessoryDevices = responseData.filter(
    (product) => product.productType === "ACCESSORY"
  );

  const handleEditProduct = (product) => {
    history.push({
      pathname: REACT_ADD_PRODUCT,
      state: product,
    });
  };

  return (
    <>
      <Box
        sx={{
          padding: "8px",
          marginLeft: "-6px",
        }}
        ref={headerRef}
      >
        <HeaderToolbar title={t("PRODUCT")} />
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row-reverse",
          justifyContent: "flex-start",
          marginTop: '-42px'
        }}
      >
        <Box
          ref={addIconRef}
          item
          sx={{
            textAlign: "center",
            padding: "10px",
            backgroundColor: process.env.REACT_APP_BG_ICON,
            borderRadius: "50%",
            cursor: "pointer",
            // marginRight: "-8px",
          }}
        >
          <Tooltip title={"Add"} onClick={handleOpen}>
            <img src={addIcon} />
          </Tooltip>
        </Box>
      </Box>
      <Box
        style={{
          padding: "0px",
          width: "100%",
          height: `${height}px`,
          overflowY: "auto",
          scrollbarWidth: "none",
          borderRadius: "10px",
          marginTop:'10px'
        }}
      >
        <div
          style={{
            flexGrow: 1,
            overflowY: "auto",
            // maxHeight: "calc(100vh - 64px)",
            height: "100%",
            overflowX: "hidden",
          }}
        >
          <Grid
            style={{
              backgroundColor: "white",
            }}
            spacing={2}
          >
            {hardwareDevices.length > 0 && (
              <Grid container spacing={2} padding={2}>
                <Grid item xs={12}>
                  <Typography
                    style={{
                      color: "#474A4E",
                      fontSize: "20px",
                      fontFamily: "font_semiBold",
                    }}
                  >
                    {t("HARDWARE")}
                  </Typography>
                </Grid>
                {hardwareDevices.map((product, index) => (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                    <Box
                      onMouseEnter={() => setHoveredIndex(product.id)}
                      onMouseLeave={() => setHoveredIndex(null)}
                      position="relative"
                      style={{
                        height: "150px",
                        backgroundColor: "#F9F9F9",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "12px",
                      }}
                    >
                      <Box
                        style={{
                          height: "92px",
                          width: "92px",
                          backgroundColor: "#D8D8D8",
                          borderRadius: "12px",
                        }}
                      >
                        <img
                          src={product.productImagePresignedUrl}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "12px",
                          }}
                        />
                      </Box>
                      {hoveredIndex === product.id && (
                        <Box
                          position="absolute"
                          top="8px"
                          right="8px"
                          display="flex"
                          flexDirection="column"
                          gap="8px"
                        >
                          <IconButton
                            size="small"
                            onClick={() => handleEditProduct(product)}
                          >
                            <EditIcon />
                          </IconButton>
                          {/* <IconButton size="small">
                          <EmployeeDeleteIcon />
                        </IconButton> */}
                        </Box>
                      )}
                    </Box>
                    <Box
                      sx={{
                        overflow: "hidden",
                        wordWrap: "break-word",
                        textOverflow: "ellipsis",
                      }}
                    >
                      <Typography
                        style={{
                          color: "#474A4E",
                          fontSize: "18px",
                          fontFamily: "font_bold",
                          whiteSpace: "normal",
                          wordBreak: "break-word", // Ensures long words break to the next line
                          overflowWrap: "break-word", // Prevents text overflow
                          textOverflow: "ellipsis", // Adds ellipsis for overflowed text
                          display: "-webkit-box",
                          WebkitLineClamp: 1, // Limits the number of lines to 2
                          WebkitBoxOrient: "vertical",
                          maxWidth: "100%", // Ensures it does not exceed the container
                          overflow: "hidden",
                        }}
                      >
                        <Tooltip
                          title={
                            product.productModel
                              ? product.productName + "+" + product.productModel
                              : product.productName
                          }
                          placement="bottom-start"
                        >
                          {product.productModel
                            ? product.productName + "+" + product.productModel
                            : product.productName}
                        </Tooltip>
                      </Typography>
                      <Typography
                        style={{
                          color: "#226BAB",
                          fontSize: "16px",
                          fontFamily: "font_semiBold",
                        }}
                      >
                        Monthly - ${product.monthlyPrice} / Onetime - $
                        {product.oneTimePrice}
                      </Typography>
                      <Tooltip title={product.description}>
                        <Typography
                          style={{
                            color: "#474A4E",
                            fontSize: "14px",
                            fontFamily: "font_regular",
                            whiteSpace: "normal",
                            wordBreak: "break-word", // Ensures long words break to the next line
                            overflowWrap: "break-word", // Prevents overflow
                            textOverflow: "ellipsis", // Adds ellipsis for overflowed text
                            display: "-webkit-box",
                            WebkitLineClamp: 3, // Limits the number of lines
                            WebkitBoxOrient: "vertical",
                            maxWidth: "100%", // Prevents width overflow
                          }}
                        >
                          {product.description}
                        </Typography>
                      </Tooltip>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            )}

            {/* Accessory Section */}
            {accessoryDevices.length > 0 && (
              <Grid container spacing={2} padding={2}>
                <Grid item xs={12}>
                  <Typography
                    style={{
                      color: "#474A4E",
                      fontSize: "20px",
                      fontFamily: "font_semiBold",
                    }}
                  >
                    {t("ACCESSORIES")}
                  </Typography>
                </Grid>
                {accessoryDevices.map((product, index) => (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                    <Box
                      onMouseEnter={() => setHoveredIndex(product.id)}
                      onMouseLeave={() => setHoveredIndex(null)}
                      position="relative"
                      style={{
                        height: "150px",
                        backgroundColor: "#F9F9F9",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "12px",
                      }}
                    >
                      <Box
                        style={{
                          height: "92px",
                          width: "92px",
                          backgroundColor: "#D8D8D8",
                          borderRadius: "12px",
                        }}
                      >
                        <img
                          src={product.productImagePresignedUrl}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "12px",
                          }}
                        />
                      </Box>
                      {hoveredIndex === product.id && (
                        <Box
                          position="absolute"
                          top="8px"
                          right="8px"
                          display="flex"
                          flexDirection="column"
                          gap="8px"
                        >
                          <IconButton
                            size="small"
                            onClick={() => handleEditProduct(product)}
                          >
                            <EditIcon />
                          </IconButton>
                        </Box>
                      )}
                    </Box>
                    <Box
                      sx={{
                        overflow: "hidden",
                        wordWrap: "break-word",
                        textOverflow: "ellipsis",
                      }}
                    >
                      <Typography
                        style={{
                          color: "#474A4E",
                          fontSize: "18px",
                          fontFamily: "font_bold",
                          whiteSpace: "normal",
                          wordBreak: "break-word", // Ensures long words break to the next line
                          overflowWrap: "break-word", // Prevents text overflow
                          textOverflow: "ellipsis", // Adds ellipsis for overflowed text
                          display: "-webkit-box",
                          WebkitLineClamp: 1, // Limits the number of lines to 2
                          WebkitBoxOrient: "vertical",
                          maxWidth: "100%", // Ensures it does not exceed the container
                          overflow: "hidden",
                        }}
                      >
                        <Tooltip
                          title={
                            product.productModel
                              ? product.productName + "+" + product.productModel
                              : product.productName
                          }
                          placement="bottom-start"
                        >
                          {product.productModel
                            ? product.productName + "+" + product.productModel
                            : product.productName}
                        </Tooltip>
                      </Typography>
                      <Typography
                        style={{
                          color: "#226BAB",
                          fontSize: "16px",
                          fontFamily: "font_semiBold",
                        }}
                      >
                        Monthly - ${product.monthlyPrice} / Onetime - $
                        {product.oneTimePrice}
                      </Typography>
                      <Tooltip title={product.description}>
                        <Typography
                          style={{
                            color: "#474A4E",
                            fontSize: "14px",
                            fontFamily: "font_regular",
                            whiteSpace: "normal",
                            wordBreak: "break-word", // Ensures long words break to the next line
                            overflowWrap: "break-word", // Prevents overflow
                            textOverflow: "ellipsis", // Adds ellipsis for overflowed text
                            display: "-webkit-box",
                            WebkitLineClamp: 3, // Limits the number of lines
                            WebkitBoxOrient: "vertical",
                            maxWidth: "100%", // Prevents width overflow
                          }}
                        >
                          {product.description}
                        </Typography>
                      </Tooltip>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            )}
          </Grid>
        </div>
      </Box>
    </>
  );
}

export default Products;
